import React from 'react';
import { useLifecycles } from 'react-use';
import { Grid } from '@mui/material';
import MessageRegisterContainer from '../containers/message/MessageRegisterContainer';
import MessageStatusContainer from '../containers/message/MessageStatusContainer';
import NewPage from '../components/NewPage';
import { piboDisconnect, piboInit } from '../pibo';
import {
  getManagerMode,
  getManagerRobotSerial,
  getSerials,
} from '../common/util';

const MessagePage = () => {
  useLifecycles(
    () => {
      if (getManagerMode()) {
        piboInit([getManagerRobotSerial()]);
      } else {
        piboInit(getSerials());
      }
    },
    () => {
      piboDisconnect();
    },
  );
  return (
    <NewPage title="메시지">
      <Grid item xs={12}>
        <MessageRegisterContainer />
      </Grid>
      <Grid item xs={12}>
        <MessageStatusContainer />
      </Grid>
    </NewPage>
  );
};

export default MessagePage;
